import { type ReactElement, useState } from 'react'

import { IconButton, ListItemIcon, Menu, MenuItem, useTheme} from '@mui/material'
import { MoreVert } from '@mui/icons-material'

import { Link } from 'react-router-dom'

export interface ActionMenuItem {
    label: string,
    icon?: ReactElement,
    link?: string,
    state?: any,
    externalLink?: boolean,
    onClick?: React.MouseEventHandler<HTMLLIElement | MouseEvent>
} 

interface ActionMenuProps { icon?:ReactElement, menuItems?: ActionMenuItem[] }

export const ActionMenu = (props:ActionMenuProps) => {

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null) 

    const theme = useTheme()

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
        event?.stopPropagation()
        setAnchorEl(null)
    }

    let menu

    if(props.menuItems) {

        const menuItems = props.menuItems.map( (item, key) => {

            const menuItem = <MenuItem key={key}    
                                       onClick={ (event) => { 
                                            event.stopPropagation()
                                            if(item.onClick) item?.onClick(event) 
                                            setAnchorEl(null)
                                        }}>
                                            {item.icon &&  <ListItemIcon>{item.icon}</ListItemIcon>}
                                            {item.label}
                                        </MenuItem>
        
            return (item.link)?
                   (<Link 
                        key={key} 
                        to={item.link}
                        target={(item.externalLink)?'_blank':''}
                        style={{color: theme.palette.text.primary, textDecoration:'none'}}
                        state={item.state}>
                            {menuItem}
                    </Link>):
                    menuItem 
        })

        menu = (
            <Menu open={ Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
                {menuItems}
            </Menu>
        )
    }

    return (
        <>
            <IconButton onClick={handleClick}>
                {props.icon ?? <MoreVert/>}
            </IconButton>
            {menu}
        </>
    )
}